const { origin } = window.location;

const HELP_CENTER = {
  TRAFFIC: '/help/article?aid=6715316029142073350',
  CONVERSION: '/help/article?aid=6715217727511855110',
  DPA: '/help/article?aid=10001004',
  LEAD: '/help/article?aid=10001624',
};

const CATALOG_BASE = `${origin}/catalogs`;
const CATALOG = {
  catalog: `${CATALOG_BASE}/list`,
  product: `${CATALOG_BASE}/product`,
  productSet: `${CATALOG_BASE}/product-sets`,
  videoList: `${CATALOG_BASE}/video-list`,
  eventSources: `${CATALOG_BASE}/event-sources`,
};

const CAMPAIGN_PLANER = {
  PLAN: '/i18n/efficient/plan',
};

const SIMPLIFY_CREATION = '/i18n/fast_creation/ads-creation/objective';
const CREATION_MODE = '/i18n/fast_creation/ad-mode';

export {
  HELP_CENTER,
  CATALOG,
  CAMPAIGN_PLANER,
  SIMPLIFY_CREATION,
  CREATION_MODE,
};
